import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import HeaderCell from './HeaderCell.jsx'
import { listBgColor, listBorderColor } from '../common.js'

const HeaderWrap = styled.div`
  background: ${listBgColor};
  border-bottom: 1px solid ${listBorderColor};
  min-height: 56px;
  width: 100%;
`

const Header = ({ columns, sortIdentifier, sortAsc, onCellClick }) => (
  <HeaderWrap className='listheader'>
    {columns.map((col, idx) => (
      <HeaderCell
        key={idx}
        active={col.identifier === sortIdentifier}
        sortAsc={sortAsc}
        labelIdentifier={col.label}
        showSortIcon={col.sort && sortIdentifier === col.identifier}
        onClick={col.sort && onCellClick ? () => onCellClick(col.identifier) : null}
        width={col.width}
      />
    ))}
  </HeaderWrap>
)

Header.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      identifier: PropTypes.string,
      width: PropTypes.string,
      sort: PropTypes.bool
    })
  ).isRequired,
  sortIdentifier: PropTypes.string,
  sortAsc: PropTypes.bool,
  onCellClick: PropTypes.func
}

Header.defaultProps = {
  columns: []
}

export default Header
